export const SET_SELECTED_SHAPE_ID = "SET_SELECTED_SHAPE_ID";
export const UPDATE_SELECTED_SHAPE_ID = "UPDATE_SELECTED_SHAPE_ID";
export const UPDATE_SHAPE = "UPDATE_SHAPE";
export const ADD_SHAPE = "ADD_SHAPE";
export const DELETE_SHAPE = "DELETE_SHAPE";
export const DISABLE_HOVER = "DISABLE_HOVER";
export const SET_OPERATION = "SET_OPERATION";
export const SHOW_ASK_AI_MODAL = "SHOW_ASK_AI_MODAL";
export const HIDE_ASK_AI_MODAL = "HIDE_ASK_AI_MODAL";
export const SET_EDITOR_SCALE = "SET_EDITOR_SCALE";
export const PUT_TO_TOP = "PUT_TO_TOP";
export const PUT_TO_BOTTOM = "PUT_TO_BOTTOM";
export const SET_LAYERS = "SET_LAYERS";
